import React from 'react';
import PropTypes from 'prop-types';
import RedirectChoice from './RedirectChoice';
import useRouter from '../../../hooks/useRouter';
import { SparklesIcon } from '@heroicons/react/24/outline';

export default function DevelopIdeaChoice(props) {
  const { history } = useRouter();

  return (
    <RedirectChoice
      icon={SparklesIcon}
      title="I have an idea and want to develop it!"
      onClick={() => history.push({
        pathname: '/my-leading',
      })}
    />
  );
};
